import React, { FC } from 'react';
import { Props } from './types';
import { i18n } from '../../i18n/translate';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { tokens } from '@everfi/design-system';

// @ts-ignore
import GeneralErrorImg from '../../images/general_error.svg';
// @ts-ignore
import NotFoundImg from '../../images/not_found.svg';
// @ts-ignore
import NoAccessImg from '../../images/no_access.svg';
// @ts-ignore
import MaintenanceImg from '../../images/maintenance.svg';
import { Image, Layout, Typography, Button as CoreButton, Link } from '../../core';

const images = {
  general_error: GeneralErrorImg,
  not_found: NotFoundImg,
  no_access: NoAccessImg,
  maintenance: MaintenanceImg,
};
export const ErrorPage: FC<Props> = props => {
  const imageUrl = images[props.type ?? ''] || GeneralErrorImg;

  /**
   * Dom
   */
  return (
    <Layout variant="flex" alignItems={'center'} flexDirection={'column'}>
      <Typography variant={'h2'}> {props.title}</Typography>
      {!!(props.errors && props.errors.length > 0) &&
        props.errors.map((error, index) => {
          const isValid = typeof error === 'string' || React.isValidElement(error);
          if (!isValid) {
            return null;
          }
          return (
            <Typography variant={'p'} key={`error[${index}]`}>
              {error}
            </Typography>
          );
        })}

      <Image path={imageUrl} description={i18n.t('Error')} width="200" />
      {props.techContact && (
        <Layout variant="container" bg={'surface-neutral-subdued'} padding={'xs'} marginBottom={'xs'}>
          <Typography>{i18n.t('Please email or call your technical contact if this error persists')}</Typography>
          <Layout variant="flex" flexDirection={'row'} gap={10}>
            <Typography>{props.techContact.technical_contact_name}</Typography>
            <Typography>{props.techContact.technical_contact_phone}</Typography>
            <Link href={sanitizeUrl(`mailto:${props.techContact.technical_contact_email}`)}>
              {props.techContact.technical_contact_email}
            </Link>
          </Layout>
        </Layout>
      )}
      {props.backButtonText && props.backButtonUrl && (
        <CoreButton variant="solid" href={props.backButtonUrl}>
          {props.backButtonText || i18n.t('Back to Learner Dashboard')}
        </CoreButton>
      )}
    </Layout>
  );
};
